import type { TypedLocale } from 'payload'

const assertUnreachable = (locale: never): never => {
  throw new Error(`Unsupported locale: ${String(locale)}`)
}

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: this switch is straightforward and easy to understand, and adding more locales in the future will be simple and maintainable
export function getProductVariantFromLabel(
  label: string,
  locale: TypedLocale,
): 'dog' | 'cat' | null {
  const normalizedLabel = label.toLowerCase()
  switch (locale) {
    case 'en':
      if (normalizedLabel.includes('dog')) return 'dog'
      if (normalizedLabel.includes('cat')) return 'cat'
      break
    case 'de':
      if (normalizedLabel.includes('hund')) return 'dog'
      if (normalizedLabel.includes('katze')) return 'cat'
      break
    case 'pl':
      if (normalizedLabel.includes('pies')) return 'dog'
      if (normalizedLabel.includes('kot')) return 'cat'
      break
    case 'es':
      if (normalizedLabel.includes('perro')) return 'dog'
      if (normalizedLabel.includes('gato')) return 'cat'
      break
    case 'fr':
      if (normalizedLabel.includes('chien')) return 'dog'
      if (normalizedLabel.includes('chat')) return 'cat'
      break
    case 'it':
      if (normalizedLabel.includes('cane')) return 'dog'
      if (normalizedLabel.includes('gatto')) return 'cat'
      break
    case 'nl':
      if (normalizedLabel.includes('hond')) return 'dog'
      if (normalizedLabel.includes('kat')) return 'cat'
      break
    default:
      assertUnreachable(locale)
  }
  return null
}
